<template>
    <news-detail-page />
</template>
<script>
    import { Component, Vue } from "vue-property-decorator";
    import NewsDetailPage from '@/components/news/detail.vue';

	@Component({
        components: {
            NewsDetailPage 
        }
    })
	export default class NewsDetail extends Vue {
        
    }
</script>
